const TOAST_ID = 'hrhg-app-bridge-toast';
const LOADING_ID = 'hrhg-app-bridge-loading';
const STYLE_ID = 'hrhg-app-bridge-style';
const DEFAULT_TOAST_DURATION = 2400;

let toastTimer: number | undefined;

const ensureStyles = (): void => {
  if (document.getElementById(STYLE_ID)) {
    return;
  }

  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `
    @keyframes hrhg-app-bridge-spin {
      to { transform: rotate(360deg); }
    }
    .hrhg-app-bridge-message {
      position: fixed;
      left: 50%;
      top: 50%;
      z-index: 2147483647;
      display: flex;
      align-items: center;
      max-width: min(80vw, 420px);
      padding: 12px 18px;
      border: 1px solid rgba(255, 255, 255, 0.12);
      border-radius: 10px;
      background: rgba(20, 20, 24, 0.9);
      box-shadow: 0 12px 36px rgba(0, 0, 0, 0.25);
      color: #fff;
      font: 14px/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      overflow-wrap: anywhere;
      pointer-events: none;
      transform: translate(-50%, -50%);
      backdrop-filter: blur(8px);
    }
    .hrhg-app-bridge-spinner {
      width: 18px;
      height: 18px;
      margin-right: 10px;
      flex: none;
      border: 2px solid rgba(255, 255, 255, 0.35);
      border-top-color: #fff;
      border-radius: 50%;
      animation: hrhg-app-bridge-spin 0.8s linear infinite;
    }
  `;
  (document.head ?? document.documentElement).appendChild(style);
};

const createMessage = (id: string, message: string): HTMLDivElement => {
  ensureStyles();
  document.getElementById(id)?.remove();

  const element = document.createElement('div');
  element.id = id;
  element.className = 'hrhg-app-bridge-message';
  element.setAttribute('role', 'status');
  element.setAttribute('aria-live', 'polite');
  element.textContent = message;
  (document.body ?? document.documentElement).appendChild(element);

  return element;
};

/**
 * 显示浏览器 Toast。
 */
export const showBrowserToast = (message: string): void => {
  createMessage(TOAST_ID, message);

  if (toastTimer !== undefined) {
    window.clearTimeout(toastTimer);
  }
  toastTimer = window.setTimeout(() => {
    document.getElementById(TOAST_ID)?.remove();
    toastTimer = undefined;
  }, DEFAULT_TOAST_DURATION);
};

/**
 * 显示可由 closeBrowserLoading 关闭的浏览器 Loading。
 */
export const showBrowserLoading = (message: string): void => {
  const element = createMessage(LOADING_ID, message || '加载中…');
  const spinner = document.createElement('span');
  const text = document.createElement('span');

  spinner.className = 'hrhg-app-bridge-spinner';
  spinner.setAttribute('aria-hidden', 'true');
  text.textContent = message || '加载中…';
  element.textContent = '';
  element.append(spinner, text);
};

/**
 * 关闭浏览器 Loading。
 */
export const closeBrowserLoading = (): void => {
  document.getElementById(LOADING_ID)?.remove();
};
